"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheBusterInterceptor = void 0;
class CacheBusterInterceptor {
    runWhen(config) {
        var _a;
        return (_a = config === null || config === void 0 ? void 0 : config.useCacheBuster) !== null && _a !== void 0 ? _a : false;
    }
    onRequest(config) {
        config.params._ = Date.now();
        return config;
    }
}
exports.CacheBusterInterceptor = CacheBusterInterceptor;
